
const options = {
  id: '_social_dialog',
  // 提示信息时间
  toastTimeout: 1000,
  template: '<div class="toast" id="_social_dialog" style="display:none"></div>',
  toastTemplate: '<p class="toast-txt">{{title}}</p>',
  iconTemplate: '<p><em class="icon icon-{{icon}}" v-bind:class="iconName"></em></p>'
}
let $element = null
const _render = function (...content) {
  if ($element == null) {
    var node = document.createElement('secetion')
    node.innerHTML = options.template
    document.body.appendChild(node)
    $element = document.getElementById(options.id)
  }
  let temp = content.join(' \r\t\n ')
  $element.innerHTML = temp
  $element.style.display = 'block'
}
// toast
const _renderToast = function ({title}) {
  var template = options.toastTemplate.replace('{{title}}', title)
  return template
}

const Dialog = {
  tips: function () {

  },
  close: function () {
    if ($element) {
      $element.style.display = 'none'
    }
    return ''
  },
  toast: function ({title, timeout = options.toastTimeout, callback = null}) {
    let toastTemplate = _renderToast({title})
    _render(toastTemplate)
    setTimeout(function () {
      Dialog.close()
      if (callback) {
        console.log('dialog - timeout - callback')
        callback()
      }
    }, timeout)
  }
}

export default Dialog



// WEBPACK FOOTER //
// ./src/plugins/dialog.js